
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { getLocalWeekly } from '@src/lib/utils/utils';
import { useRouter } from 'next/router';
import { weekliyData } from '@src/lib/data/weeklyList';
import SeoComponent from '@src/view/common/seo/SeoCompnent';

const DailyComponent = dynamic<any>(
  () =>
    import('@src/view/components/daily').then((mod: any) => mod.DailyComponent),
  { ssr: false },
);

/**
 * - 오늘 요일정보  getlocalweekly()
 * - hash 예외처리 (weeklyData 범위 내의 영역인지 && 대소문자 확인)
 * - 이외 문자열 오늘 요일로 변경
 * - 페이지 예외처리 hash값에 따른 slide 이동
 */

const Index = (props: any) => {
  /**
   * 요일에 대한 index (0 ~ 6까지 허용) 그외는 해당 요일로 replace
   */
  const [hashIndex, setHashIndex] = useState(-1);
  const router = useRouter();

  useEffect(() => {
    const current = getLocalWeekly();
    const hash = window.location.hash;

    if (!hash) {
      // window.location.hash = weekliyData[current].en;
      router.replace(`/weekly#${weekliyData[current].en}`);
      setHashIndex(current);
      return;
    }

    // hash 값 비교 대문자로 변경, weeklyData와 비교.
    const replaceHash = hash.replace('#', '').toUpperCase();
    const findHashIndex: number = weekliyData.findIndex(obj => {
      return obj.en === replaceHash;
    });

    if (findHashIndex < 0) {
      window.location.hash = weekliyData[current].en;
      setHashIndex(current);
      return;
    }

    setHashIndex(findHashIndex);
  }, [router]);

  return (
    <>
      <SeoComponent.Originals />
      <DailyComponent weekId={hashIndex} />
    </>
  );
};

const __Page_Next_Translate__ = Index;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: false,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  